<template>
  <div class="layout-box">
    <LayoutHeader headtitle="工业APP"></LayoutHeader>
    <div class="secondary-content">
<!--      <GoBack></GoBack>-->
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 热门应用</div>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in explistdata" :key="index">
          <a :href='item.url' target="_blank"><img :src='item.img'/><p>{{item.name}}</p></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'Industrial',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      explistdata:[
        {img:require('../../assets/img/EMS.jpg'),url:'https://www.supos.com/product-ems.html',name:'EMS能源管理'},
        {img:require('../../assets/img/LIMS.png'),url:'https://www.supos.com/product-lims.html',name:'LIMS实验室管理'},
        {img:require('../../assets/img/EAM.jpg'),url:'https://www.supos.com/product-eam.html',name:'EAM设备管理'},
        {img:require('../../assets/img/SES.png'),url:'https://www.supos.com/product-ses.html',name:'SES安全管理'},
        {img:require('../../assets/img/PSM.jpg'),url:'https://www.supos.com/product-psm.html',name:'PSM生产调度管理'},
        {img:require('../../assets/img/WMS.jpg'),url:'https://www.supos.com/product-wms.html',name:'WMS仓库管理'},
      ]
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-list{
  overflow: auto;
  height: calc(100% - 90px);
  padding: 30px 0 0 18px;
}

.experts-list::-webkit-scrollbar{
  display: none;
}

.experts-list li{
  width: 311px;
  height: 330px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  display: flex;
  justify-content: space-between;
}

.experts-list li:hover{
  background: #2095EF;
}

.experts-list li img{
  width: 311px;
}

.experts-list p{
  font-size: 18px;
  text-align: center;
  color: #fff;
  text-decoration: none;
  line-height: 260%;
  background: #0B42AF;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-industrial-list.vue